import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { memorialOwnerGuard } from './core/guards/memorial-owner.guard';
import { adminGuard } from './core/guards/admin.guard';
import { superAdminGuard } from './core/guards/super-admin.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./features/landing/landing-page/landing-page.component').then(
        (m) => m.LandingPageComponent
      ),
  },
  {
    path: 'auth',
    children: [
      {
        path: 'login',
        loadComponent: () =>
          import('./features/auth/login/login.component').then((m) => m.LoginComponent),
      },
      {
        path: 'register',
        redirectTo: 'login',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: 'memorials',
    loadComponent: () =>
      import('./features/memorials/memorial-list/memorial-list.component').then(
        (m) => m.MemorialListComponent
      ),
  },
  {
    path: 'memorials/new',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/memorials/memorial-form/memorial-form.component').then(
        (m) => m.MemorialFormComponent
      ),
  },
  {
    path: 'memorials/:id',
    loadComponent: () =>
      import('./features/memorials/memorial-detail/memorial-detail.component').then(
        (m) => m.MemorialDetailComponent
      ),
  },
  {
    path: 'memorials/:id/chat',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/memorials/memorial-chat/memorial-chat.component').then(
        (m) => m.MemorialChatComponent
      ),
  },
  {
    path: 'memorials/:id/edit',
    canActivate: [authGuard, memorialOwnerGuard],
    loadComponent: () =>
      import('./features/memorials/memorial-form/memorial-form.component').then(
        (m) => m.MemorialFormComponent
      ),
  },
  {
    path: 'memories/:id',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/memories/memory-detail/memory-detail.component').then(
        (m) => m.MemoryDetailComponent
      ),
  },
  {
    path: 'pricing',
    loadComponent: () =>
      import('./features/pricing/pricing-page/pricing-page.component').then(
        (m) => m.PricingPageComponent
      ),
  },
  {
    path: 'subscription',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/account/subscription/subscription.component').then(
        (m) => m.SubscriptionComponent
      ),
  },
  {
    path: 'm/:slug',
    loadComponent: () =>
      import('./features/public/public-memorial/public-memorial.component').then(
        (m) => m.PublicMemorialComponent
      ),
  },
  {
    path: 'privacy',
    loadComponent: () =>
      import('./features/legal/privacy-policy/privacy-policy.component').then(
        (m) => m.PrivacyPolicyComponent
      ),
  },
  {
    path: 'terms',
    loadComponent: () =>
      import('./features/legal/terms-of-use/terms-of-use.component').then(
        (m) => m.TermsOfUseComponent
      ),
  },
  {
    path: 'admin',
    children: [
      {
        path: 'login',
        loadComponent: () =>
          import('./features/admin/admin-login/admin-login.component').then(
            (m) => m.AdminLoginComponent
          ),
      },
      {
        path: 'dashboard',
        canActivate: [adminGuard],
        loadComponent: () =>
          import('./features/admin/admin-dashboard/admin-dashboard.component').then(
            (m) => m.AdminDashboardComponent
          ),
      },
      {
        path: 'users',
        canActivate: [adminGuard],
        loadComponent: () =>
          import('./features/admin/admin-users/admin-users.component').then(
            (m) => m.AdminUsersComponent
          ),
      },
      {
        path: 'memorials',
        canActivate: [adminGuard],
        loadComponent: () =>
          import('./features/admin/admin-memorials/admin-memorials.component').then(
            (m) => m.AdminMemorialsComponent
          ),
      },
      {
        path: 'memorials/:id',
        canActivate: [adminGuard],
        loadComponent: () =>
          import('./features/admin/admin-memorial-detail/admin-memorial-detail.component').then(
            (m) => m.AdminMemorialDetailComponent
          ),
      },
      {
        path: 'subscriptions',
        canActivate: [adminGuard],
        loadComponent: () =>
          import('./features/admin/admin-subscriptions/admin-subscriptions.component').then(
            (m) => m.AdminSubscriptionsComponent
          ),
      },
      {
        path: 'audit-log',
        canActivate: [superAdminGuard],
        loadComponent: () =>
          import('./features/admin/admin-audit-log/admin-audit-log.component').then(
            (m) => m.AdminAuditLogComponent
          ),
      },
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'memorials',
  },
];
